
import {Component} from 'ng-metadata/core';

import { SkipToService } from './skipTo.service';
import {SmoothScrollUtil} from '../../../nddUtils/smoothScrollUtil.service';



@Component({
selector: 'prm-skip-to',
templateUrl: 'components/search/topbar/skipTo/skip-to.html',
})


export class PrmSkipTo{

    constructor(private skipToService: SkipToService, private smoothScrollUtil: SmoothScrollUtil) {

    }

    private scrollToElementId(eID){
        this.smoothScrollUtil.scrollTo(eID,'','');
    }

    get skipLinks(){
        return this.skipToService.skipLinks;
    }

    public getLabelValue(link) {
        if (link == 'advanced-search') {
            return 'advancedSearch';
        }
        return link;
    }

}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/topbar/skipTo/skipTo.directive.ts